import { useEffect } from "react"
import { connectSocket } from "../socket"
import { connectBotSocket } from "../botSocket"
import { useAuth } from "../context/AuthContext"

export const useSocket = () => {
    const { userId } = useAuth();

    // eslint-disable-next-line no-undef
    const serverUrl = process.env.REACT_APP_SERVER_URL;

    // eslint-disable-next-line no-undef
    const botServerUrl = process.env.REACT_APP_BOT_SERVER_URL;

    useEffect(() => {
        if (!userId) return;

        const socketEventEmitter = connectSocket(serverUrl, userId);
        const botSocketEventEmitter = connectBotSocket(botServerUrl, userId);

        return () => {
            socketEventEmitter.removeAllListeners();
            botSocketEventEmitter.removeAllListeners();
        };
    }, [userId, serverUrl, botServerUrl]);
}
